<div class="confirmation">
  <lx-layout [withSidebar]="false">
    <div layout-main>
      <div class="confirmation">
        <img class="confirmation__icon-image" ngSrc="assets/images/confirmation.svg" alt="Edit" height="48" width="48" />
        <h1 class="confirmation__title" i18n>Thank you!</h1>
        <div class="confirmation__student">
          <div i18n>Hi {{ studentFirstName() }}.</div>
          <div i18n>Your place is now guaranteed</div>
        </div>
        @if (courseStartDate()) {
        <lx-next-steps [courseStartDate]="courseStartDate()!"></lx-next-steps>
        }
      </div>
      <lx-button id="btn-exit" [text]="backButtonLabel()" [block]="true" [buttonStyle]="'primary'" data-qa="exit-button" (buttonClick)="onExit()"> </lx-button>
    </div>
  </lx-layout>
</div>
